export default "__VITE_ASSET__5e50cd92__"